import { APIService } from "@/services/api";
import { API } from "@/lib/api";
import { ReadTaxOffice, WriteTaxOffice } from "@/types/taxOffice";

export const TaxOfficeService = new APIService<ReadTaxOffice, WriteTaxOffice>(
  API.TaxOffices,
);
export const fetchTaxOfficeList = TaxOfficeService.getList;
export const fetchTaxOffice = TaxOfficeService.get;
export const createTaxOffice = TaxOfficeService.post;
export const updateTaxOffice = TaxOfficeService.patch;
